"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _universalCookie = _interopRequireDefault(require("universal-cookie"));

var _iconClose = _interopRequireDefault(require("../../../shared/icons/icon-close.svg"));

var _CustomReactMarkdown = _interopRequireDefault(require("../../../shared/components/MarkdownRenderers/CustomReactMarkdown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var BasicBanner = /*#__PURE__*/function (_Component) {
  _inherits(BasicBanner, _Component);

  var _super = _createSuper(BasicBanner);

  function BasicBanner(props) {
    var _this;

    _classCallCheck(this, BasicBanner);

    _this = _super.call(this, props);
    _this.cookies = new _universalCookie["default"]();
    _this.state = {
      display: _this.setDefaultBannerStatus()
    };
    _this.closeBanner = _this.closeBanner.bind(_assertThisInitialized(_this));
    _this.setBannerClosedTime = _this.setBannerClosedTime.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(BasicBanner, [{
    key: "setDefaultBannerStatus",
    value: function setDefaultBannerStatus() {
      var bannerCookie = this.cookies.get('isShowBanner');

      if (bannerCookie) {
        var sessionId = this.cookies.get('sid');

        if (sessionId === bannerCookie) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "setBannerClosedTime",
    value: function setBannerClosedTime() {
      var expires = new Date();
      var millisecondsInDay = 86400000;
      var sessionId = this.cookies.get('sid');
      expires.setTime(expires.getTime() + millisecondsInDay);
      this.cookies.set('isShowBanner', sessionId, {
        path: '/',
        expires: expires
      });
    }
  }, {
    key: "closeBanner",
    value: function closeBanner() {
      this.setBannerClosedTime();
      this.setState({
        display: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.state.display;
      var _this$props = this.props,
          message = _this$props.message,
          secondaryMessage = _this$props.secondaryMessage,
          allowClose = _this$props.allowClose;
      var bannerClass = (0, _classnames["default"])({
        'site-header__banner-wrapper-basic': display,
        'site-header__banner-wrapper--hide': !display,
        'site-header__banner-wrapper--heavy': !!secondaryMessage
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: bannerClass
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "se-container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "site-banner-basic"
      }, /*#__PURE__*/_react["default"].createElement(_CustomReactMarkdown["default"], {
        className: "site-banner__message-basic",
        source: message
      }), secondaryMessage && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "site-banner__message-seperator"
      }), /*#__PURE__*/_react["default"].createElement(_CustomReactMarkdown["default"], {
        className: "site-banner__message-basic",
        source: secondaryMessage
      })), allowClose && /*#__PURE__*/_react["default"].createElement("div", {
        className: "site-banner__close-button",
        onClick: this.closeBanner,
        onKeyPress: this.closeBanner,
        role: "button",
        tabIndex: 0
      }, /*#__PURE__*/_react["default"].createElement(_iconClose["default"], {
        className: "site-banner__close-button-icon"
      })))));
    }
  }], [{
    key: "getDomId",
    value: function getDomId() {
      return 'slot_header_banner';
    }
  }]);

  return BasicBanner;
}(_react.Component);

BasicBanner.propTypes = {
  message: _propTypes["default"].string.isRequired,
  secondaryMessage: _propTypes["default"].string,
  allowClose: _propTypes["default"].bool
};
BasicBanner.defaultProps = {
  secondaryMessage: null,
  allowClose: true
};
var _default = BasicBanner;
exports["default"] = _default;